import { Card, Typography, Divider, Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import MachineTab from "./MachineTab";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";

const AddCannedVendingMachine = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [defaultIndex, setDefaultIndex] = useState("1");

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Canned Vending Machine", permissionJson, "edit")) {
        navigate("/manage-canned-vending-machine");
      }
    } else {
      if (!checkPermissionAction("Canned Vending Machine", permissionJson, "add")) {
        navigate("/manage-canned-vending-machine");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTabChange = (key) => {
    setDefaultIndex(key);
  };

  return (
    <>
      <Card className="res-time">
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2 cursor-pointer" onClick={() => navigate(-1)} />
          {id ? "Edit" : "Add"} Canned Vending Machine
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Tabs activeKey={defaultIndex} onChange={onTabChange}>
            <Tabs.TabPane tab={"Machine Details"} key={1}>
              <MachineTab />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <Divider />
      </Card>
    </>
  );
};

export default AddCannedVendingMachine;
